﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';

export default class KDMZAsyncFormResultlist extends TKCustomElementFactory {
    inputField?: HTMLInputElement;
    targetContainer?: HTMLElement;
    formular?: HTMLFormElement;
    submitBtn?: HTMLButtonElement;
    url: string;

    constructor() {
        super();
        this.inputField = this.querySelector('#sapdebi-find') || undefined;
        this.targetContainer = this.querySelector('[data-async-form-resultlist-target]') || undefined;
        this.formular = this.querySelector('form') || undefined;
        this.submitBtn = this.formular!.querySelector('button[type="submit"]') || undefined;
        this.url = this.formular?.action || '';
    }

    connectedCallback(): void {
        if (!this.formular || !this.targetContainer) throw new Error('KDMZAsyncFormResultlist: something is missing!');
        this.registerEventListener();
    }

    registerEventListener() {
        // this.pushListener({
        //     event: 'submit',
        //     element: this.formular!,
        //     action: this.formSearch.bind(this),
        // });

        this.pushListener({
            event: 'click',
            element: this.submitBtn!,
            action: this.formSearch.bind(this),
        });
    }

    formSearch(event: Event): void {
        event.preventDefault();

        if (this.inputField && this.inputField.value !== '') {
            const payload = {
                inputField: this.inputField.value,
            };

            const htmlString = '<div class="kdmz-loading-icon"><div></div><div></div><div></div><div></div></div>';
            const loadingElement = document.createElement('div');
            loadingElement.innerHTML = htmlString;
            loadingElement.classList.add('flex', 'flex--justify-center', 'spacer-mb-4', 'spacer-mt-4');
            this.targetContainer!.innerHTML = '';
            this.targetContainer!.append(loadingElement);
            this.inputField.disabled = true;
            fetchRequest({
                requestURL: this.url!,
                payload,
                resolveHandler: this.resultlistInsert.bind(this),
            });
        }
    }

    resultlistInsert(response) {
        if (this.targetContainer) {
            this.targetContainer.innerHTML = response.dataAsHtml;
            this.inputField!.disabled = false;
        }
    }
}
